export default __webpack_public_path__ + "static/media/chevron_right.e5875939.svg";